import React, {useState, createContext} from 'react'
import moment from 'moment'

const AuditDetailsContext = createContext()

function AuditDetailsContextProvider(props) {
  const [id, setAuditId] = useState()
  const [name, setName] = useState('Audit-' + Date.now())
  const [template_name, setTemplateName] = useState()
  const [method, setMethod] = useState('barcode_scan')
  const [start_date, setStartDate] = useState(moment(new Date()).format('MM/DD/YYYY'))
  const [due_date, setDueDate] = useState('')
  const [allow_scanning_after_due_date, setAllowScanningAfterDurDate] = useState(false)
  const [due_soon_days, setDueSoonDays] = useState(3)
  const [gps_location, setGpsDetails] = useState(false)
  const [asset_details, setAssetDetails] = useState(false)
  const [signature, setSignature] = useState(false)
  const [status, setAuditStatus] = useState()
  const [in_buffer_time, setInBufferTime] = useState(false)

  const resetAuditDetails = () => {
    setName('Audit-' + Date.now())
    setTemplateName()
    setMethod('barcode_scan')
    setStartDate(moment(new Date()).format('MM/DD/YYYY'))
    setDueDate()
    setAllowScanningAfterDurDate(false)
    setDueSoonDays(3)
    setGpsDetails(false)
    setAssetDetails(false)
    setInBufferTime(false)
  }
  const value = {
    id,
    name,
    template_name,
    method,
    start_date,
    due_date,
    allow_scanning_after_due_date,
    due_soon_days,
    gps_location,
    asset_details,
    status,
    in_buffer_time,
    signature,

    setAuditId,
    setName,
    setTemplateName,
    setMethod,
    setStartDate,
    setDueDate,
    setAllowScanningAfterDurDate,
    setDueSoonDays,
    setGpsDetails,
    setAssetDetails,
    setSignature,
    setAuditStatus,
    resetAuditDetails,
    setInBufferTime,
  }

  return <AuditDetailsContext.Provider value={value}>{props.children}</AuditDetailsContext.Provider>
}

const AuditDetailsContextConsumer = AuditDetailsContext.Consumer

export {AuditDetailsContext, AuditDetailsContextProvider, AuditDetailsContextConsumer}
